//
// ─── IMPORTS ────────────────────────────────────────────────────────────────────
//
const { version } = require("../../package.json")

// Vendors
//import "~overlayscrollbars/styles/overlayscrollbars.css";

// Bootstrap
import "@popperjs/core" // Popper is required for dropdowns, popovers and tooltips.
import {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    OffCanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip,
} from "bootstrap"

import Splide from "@splidejs/splide" //? https://splidejs.com/
import GLightbox from "glightbox/dist/js/glightbox.js" //? https://github.com/biati-digital/glightbox
import AOS from "aos"
import { OverlayScrollbars } from "overlayscrollbars" //? https://kingsora.github.io/OverlayScrollbars/

import * as Ladda from "ladda"
import "ladda/css/ladda.scss"

//import './components/cookieConsent/cookieOptions';
import "./components/imageLazyLoad" // Lazy load images
import "./components/webp"

// Components
import "./components/mobileMenu"
import "./components/mobileSelectNav"
import "./components/fixedHeader"
// import './components/dropdownOnHover' //Not required. Causes issues with dropdowns
import "./components/productGallery"
import "./components/forms"
import { initQtyInputGroups, initLaddaButtons } from "./components/forms"
import "./components/tableRowLinks"
import "./components/search"
import "./components/mailing"
import "./components/shopFilters"
import "./components/mailListModal"
import "./components/deliveryCountdown"

// Page specific
import "./components/homeSlider"

import "./pages/cart/cart"
import "./pages/checkout/checkout"
import "./pages/mealBuilder"
import "./pages/account"
import "./pages/deliveryCheck"
import "./pages/product"
import "./pages/franchise"

//
// ─── CODE ───────────────────────────────────────────────────────────────────────
//

// initialise AOS
AOS.init()

console.log(`Ready Fit Go v${version}`)

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelectorAll('[data-bs-toggle="dropdown"]').length > 0) {
        var dropdowns = [
            document.querySelectorAll('[data-bs-toggle="dropdown"]')[0],
        ]?.map((el) => new Dropdown(el))
    }
})

const popoverTriggerList = document.querySelectorAll(
    '[data-bs-toggle="popover"]'
)
const popoverList = [...popoverTriggerList].map(
    (popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl)
)

$(function () {
    //Toggleable elements
    $("body").on("click", ".toggle-element", function (e) {
        e.preventDefault()
        var id = $(this).data("id")
        var $element = $(`#toggle-element-${id}`)
        $($element).slideToggle()
    })
})

//
// ─── INITIALISE LADDA BUTTONS ───────────────────────────────────────────────────
initLaddaButtons()

// ─── Quantity Group Elements ────────────────────────────────────────────────────
initQtyInputGroups()
